import { DashboardDateRangeDefaults } from './DashboardDateRangeFilterDropdown.types'

export const DashboardDateRangeDefaultsLabel = {
  [DashboardDateRangeDefaults.LAST_7_DAYS]: 'Last 7 Days',
  [DashboardDateRangeDefaults.LAST_30_DAYS]: 'Last 30 Days',
  [DashboardDateRangeDefaults.LAST_90_DAYS]: 'Last 90 Days',
  [DashboardDateRangeDefaults.LAST_YEAR]: 'Last Year',
}

// "All Activities" is an Activities-page-only option that applies no date-range limit.
// It is intentionally NOT part of DashboardDateRangeDefaults so the Overview Dashboard's
// date-range switches never receive it (they'd fall through to a start-end parse).
export const ALL_ACTIVITIES_VALUE = 'all_time'
export const ALL_ACTIVITIES_LABEL = 'All Activities'
